import React from 'react';

const VARIANT_CLASSES = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    danger: 'btn-danger',
    success: 'btn-success',
};

export function Button({
    children,
    variant = 'primary',
    size = 'md',
    disabled = false,
    onClick,
    type = 'button',
    fullWidth = false,
    className = '',
    ...props
}) {
    const base = VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary;
    const sizeClass = size === 'sm' ? 'btn-sm' : '';
    const widthClass = fullWidth ? 'w-full' : '';

    return (
        <button
            className={`${base} ${sizeClass} ${widthClass} ${className}`}
            disabled={disabled}
            onClick={onClick}
            type={type}
            {...props}
        >
            {children}
        </button>
    );
}
